"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EmployeeRight_value, _EmployeeRight_bit, _EmployeeRight_str, _enDeCoder_enums, _enDeCoder_values;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeRightEnDeCoder = exports.EmployeeRight = void 0;
const claims_1 = require("./claims");
class EmployeeRight {
    constructor(value, bit, str) {
        _EmployeeRight_value.set(this, void 0);
        _EmployeeRight_bit.set(this, void 0);
        _EmployeeRight_str.set(this, void 0);
        __classPrivateFieldSet(this, _EmployeeRight_value, value, "f");
        __classPrivateFieldSet(this, _EmployeeRight_bit, bit, "f");
        __classPrivateFieldSet(this, _EmployeeRight_str, str, "f");
    }
    value() {
        return __classPrivateFieldGet(this, _EmployeeRight_value, "f");
    }
    bit() {
        return __classPrivateFieldGet(this, _EmployeeRight_bit, "f");
    }
    str() {
        return __classPrivateFieldGet(this, _EmployeeRight_str, "f");
    }
    toString() {
        return __classPrivateFieldGet(this, _EmployeeRight_str, "f");
    }
    toJSON() {
        return this.toString();
    }
}
exports.EmployeeRight = EmployeeRight;
_EmployeeRight_value = new WeakMap(), _EmployeeRight_bit = new WeakMap(), _EmployeeRight_str = new WeakMap();
// Enum contains 6 values. In bytes it 81 bytes
EmployeeRight.BACKOFFICE_USER_USER_R = new EmployeeRight(168378079, 0, "BACKOFFICE_USER_USER_R");
EmployeeRight.OPEN = new EmployeeRight(168378080, 1, "OPEN");
EmployeeRight.OPEN_DRIVE_SHIFT = new EmployeeRight(168378081, 2, "OPEN_DRIVE_SHIFT");
EmployeeRight.VIEW_DRIVER_SHIFT_DATA = new EmployeeRight(168378082, 3, "VIEW_DRIVER_SHIFT_DATA");
EmployeeRight.VIEW_TIPS = new EmployeeRight(168378083, 4, "VIEW_TIPS");
EmployeeRight.WORK_LOG = new EmployeeRight(168378084, 5, "WORK_LOG");
const byEnum = Object.values(EmployeeRight).reduce((acc, v) => { acc[v.value()] = v.str(); return acc; }, {});
class enDeCoder {
    constructor() {
        _enDeCoder_enums.set(this, Object.values(EmployeeRight).sort((a, b) => {
            if (a.str() < b.str())
                return -1;
            if (a.str() > b.str())
                return 1;
            return 0;
        }));
        _enDeCoder_values.set(this, Object.keys(EmployeeRight));
    }
    toEnum(s) {
        return EmployeeRight[s];
    }
    fromEnum(r) {
        return byEnum[(r === null || r === void 0 ? void 0 : r.value()) || -1];
    }
    toEnums(...s) {
        return this.toPermissions(...s).toEnums();
    }
    toPermissions(...s) {
        return claims_1.Permissions.FromString(exports.EmployeeRightEnDeCoder, ...s);
    }
    enums() {
        return __classPrivateFieldGet(this, _enDeCoder_enums, "f");
    }
    values() {
        return __classPrivateFieldGet(this, _enDeCoder_values, "f");
    }
    name() {
        return "EmployeeRight";
    }
}
_enDeCoder_enums = new WeakMap(), _enDeCoder_values = new WeakMap();
exports.EmployeeRightEnDeCoder = new enDeCoder();
//# sourceMappingURL=employee-right.js.map